// services/labelService.js
import html2canvas from 'html2canvas';
import JsBarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import api from '../services/api-configuration';
import { getAllWarehouses } from '../services/apis';
import UKLogo from './uk-black-white.png';

export const generateQR = async (text) => {
    try {
        const options = {
            margin: 0,
            width: 200,
            height: 200,
            color: {
                dark: '#000000',
                light: '#ffffff'
            }
        };
        return await QRCode.toDataURL(text, options);
    } catch (err) {
        console.error('QR Code generation error:', err);
        return null;
    }
};

export const fetchPDIData = async (chassisNo) => {
    try {
        const response = await api.post('/getVehicleOrderInfo', { chassis_no: chassisNo });
        if (response.status === 200) {
            return {
                success: true,
                data: {
                    chassis_no: response.data.chassis_no || "",
                    dealer: (response.data.shipping_address === "-/" ? "" : (response.data.shipping_address || "").toLocaleUpperCase("tr-TR")),
                    brand: response.data.brand || "",
                    model: response.data.model || "",
                    groupage_no: response.data.chassis_no || "",
                    pdi_date: response.data.pdi_exit_date
                        ? new Date(response.data.pdi_exit_date).toLocaleDateString('en-US', {
                            weekday: 'long',
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                        })
                        : "",
                    warehouse: response.data.warehouse || "",
                    adress: response.data.address_code || ""
                }
            };
        }
        throw new Error('API response was not ok');
    } catch (error) {
        console.error('Error fetching PDI data:', error);
        toast.error('Veri çekilirken bir hata oluştu');
        return null;
    }
};

export const createBarcodeImage = async (groupageNo) => {
    const canvas = document.createElement('canvas');
    canvas.style.width = '315px';
    canvas.style.height = '157px';
    const scale = window.devicePixelRatio || 2;
    canvas.width = 315 * scale;
    canvas.height = 157 * scale;

    JsBarcode(canvas, groupageNo, {
        format: 'CODE128',
        width: 3.15,
        height: 110,
        displayValue: true,
        fontSize: 25,
        textMargin: 6.3,
        margin: 0,
        background: '#ffffff',
        lineColor: '#000000'
    });

    // Rotate barcode
    const rotatedCanvas = document.createElement('canvas');
    const ctx = rotatedCanvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;

    rotatedCanvas.width = canvas.height;
    rotatedCanvas.height = canvas.width;
    rotatedCanvas.style.width = canvas.style.height;
    rotatedCanvas.style.height = canvas.style.width;

    ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);

    return rotatedCanvas.toDataURL();
};

const createLabelContainer = (data, qrImage, barcodeImage) => {
    const container = document.createElement('div');
    container.innerHTML = `
        <div style="width: 95mm; height: 125mm; font-family: sans-serif; padding: 2mm 6mm 0mm 3mm; background: white;">
            <div style="padding: 0; height: 100%; display: flex; flex-direction: column;">
                <div style="display: flex; align-items: center; height: 31mm; gap: 2mm;">
                    <div style="height: 70%;">
                        <img alt="UK Logo" src=${UKLogo} style="height: 100%; display: block;">
                    </div>
                    <div style="width:100%">
                        <div style="font-size: 28px; font-weight: 700; text-align: center; width: 100%; border: 0.5mm solid #000; padding: 2mm; margin-bottom: 2mm; background: white;">PDI</div>
                        <div style="font-size: 16px; font-weight: 700; padding-left: 2mm;">${data.groupage_no}</div>
                    </div>
                </div>
                <div style="flex: 1; border-top: 0.5mm solid #000; display: grid; grid-template-columns: 18mm 1fr; gap: 0mm; padding-top: 2mm; max-height: 90mm; overflow: hidden;">
                    <div style="height: 100%; display: grid; grid-template-rows: auto 1fr;">
                        <span style="font-size: 3.5mm; font-weight: 700; padding: 0 3mm">BAYİ :</span>
                        <div style="height: 80mm; padding: 2mm 0">
                            <img alt="Barkod" src="${barcodeImage}" style="height: 100%; width: 100%; object-fit: contain; max-height: 72mm; display: block;">
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 2mm;">
                        <p style="min-height: 5mm; font-size:2.9mm; font-weight: 700; margin: 0;">${data.dealer || ""}</p>
                        <div style="display: flex; justify-content: space-between; align-items: start; gap: 2mm; padding-left: 2mm;">
                            <div style="border: 0.5mm solid #000; padding: 2mm; width: 70%; font-weight: 700; background: white;">
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.brand}</small>
                                <small style="font-size: 10px; font-weight: 700; display: block; margin-top:1mm">${data.model}</small>
                            </div>
                            <div style="width: 25%;">
                                <img alt="QR" src="${qrImage}" style="width: 100%; display: block;">
                            </div>
                        </div>
                        <div style="padding-left:2mm">
                            <div style="display:flex;justify-content:space-between;border-bottom:0.5mm solid #000;padding:2mm">
                                <small style="font-size: 10px; font-weight: 700; display: block;">PDI Tarih</small>
                                <small style="font-size: 10px; font-weight: 700; display: block;">PDI Bölgesi</small>
                            </div>
                            <div style="display:flex;justify-content:space-between;padding:2mm; padding-inline:0;">
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.pdi_date}</small>
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.warehouse}</small>
                            </div>
                            <div style="font-size: 50px; font-weight: bold; text-align: left; margin-top: 3mm;">${data.adress}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    return container;
};

// Depo bazlı yazdırma konfigürasyonu
export const WAREHOUSE_PRINT_CONFIG = {
    '23': { // Haydarpaşa
        hasPrint: true,
        uploadEndpoint: '/pdi-upload',
        printEndpoint: '/pdi-print'
    },
    '26': { // İzmit
        hasPrint: true,
        uploadEndpoint: '/pdi-upload',
        printEndpoint: '/pdi-print-izmit'
    }
    // Diğer tüm depolar için varsayılan olarak yazdırma özelliği kapalı
};

export const checkWarehouseSelection = async () => {
    const storedWarehouseId = localStorage.getItem("warehouse");
    const storedWarehouseName = localStorage.getItem("warehouseName");

    if (storedWarehouseId && storedWarehouseName) {
        return {
            id: Buffer.from(storedWarehouseId, 'base64').toString('ascii'),
            warehouse_name: storedWarehouseName
        };
    }

    const showWarehouseModal = async (warehouses = [], hasError = false) => {
        let selectedValue = null;
        let selectedName = null;
        const result = await Swal.fire({
            title: 'Depo Seçimi',
            html: `
                <div class="warehouse-modal">
                    ${hasError ?
                    `<div class="error-message">
                            <i class="fa fa-exclamation-circle"></i>
                            Depo listesi alınamadı
                        </div>`
                    :
                    `<div class="select-container">
                            <select id="warehouse-select">
                                <option value="">Depo Seçiniz</option>
                                ${warehouses.map(w => {
                        const hasPrint = WAREHOUSE_PRINT_CONFIG[w.id]?.hasPrint;
                        return `<option value="${w.id}" data-name="${w.warehouse_name}">${w.warehouse_name}${!hasPrint ? ' (Yazdırma Yok)' : ''}</option>`;
                    }).join('')}
                            </select>
                        </div>`
                }
                </div>
                <style>
                    .warehouse-modal {
                        padding: 10px;
                        max-width: 400px;
                        margin: 0 auto;
                    }
                    .error-message {
                        color: #dc3545;
                        padding: 15px;
                        border-radius: 4px;
                        background: #fff5f5;
                        margin-bottom: 10px;
                        font-size: 16px;
                        text-align: center;
                    }
                    .select-container {
                        margin: 15px 0;
                    }
                    #warehouse-select {
                        width: 100%;
                        padding: 10px;
                        border: 1px solid #ced4da;
                        border-radius: 4px;
                        font-size: 16px;
                        background-color: white;
                    }
                    #warehouse-select:focus {
                        border-color: #80bdff;
                        outline: 0;
                        box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
                    }
                </style>
            `,
            confirmButtonText: hasError ? 'Tekrar Dene' : 'Seç',
            confirmButtonColor: '#0d6efd',
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: '360px',
            customClass: {
                container: 'warehouse-select-modal',
                popup: 'warehouse-select-popup',
                title: 'text-center fs-5 fw-bold'
            },
            preConfirm: () => {
                if (hasError) return true;

                const select = document.getElementById('warehouse-select');
                if (!select.value) {
                    Swal.showValidationMessage('Lütfen bir depo seçiniz');
                    return false;
                }
                selectedValue = select.value;
                selectedName = select.options[select.selectedIndex].getAttribute('data-name');
                return true;
            }
        });

        if (hasError) {
            return result.isConfirmed ? 'retry' : null;
        }

        if (result.isConfirmed && selectedValue && selectedName) {
            // ID'yi base64 ile şifrele
            localStorage.setItem("warehouse", Buffer.from(selectedValue.toString()).toString('base64'));
            // Depo adını direkt olarak sakla
            localStorage.setItem("warehouseName", selectedName);

            return {
                id: selectedValue,
                warehouse_name: selectedName
            };
        }
        return null;
    };

    try {
        let retry = true;
        while (retry) {
            const warehouses = await getAllWarehouses();
            if (!warehouses || warehouses.length === 0) {
                const result = await showWarehouseModal([], true);
                retry = result === 'retry';
                continue;
            }

            const selectedWarehouse = await showWarehouseModal(warehouses, false);
            return selectedWarehouse;
        }
        return null;
    } catch (error) {
        console.error('Error fetching warehouses:', error);
        const result = await showWarehouseModal([], true);
        if (result === 'retry') {
            return checkWarehouseSelection();
        }
        return null;
    }
};

export const printLabel = async (chassisNo, warehouseId) => {
    // Early return if no warehouse ID or printing capability
    if (!warehouseId) {
        toast.error('Depo seçimi yapılmadan etiket yazdırılamaz');
        return false;
    }
    const warehouseConfig = WAREHOUSE_PRINT_CONFIG[warehouseId];
    if (!warehouseConfig || !warehouseConfig.hasPrint) {
        // toast.error('Seçili depoda yazdırma özelliği bulunmamaktadır');
        return false;
    }

    try {
        // Parallel data fetching and QR/Barcode generation
        const [pdiData, qrImage, barcodeImage] = await Promise.all([
            fetchPDIData(chassisNo),
            generateQR(chassisNo, {
                margin: 0,
                width: 150,  // Reduced size
                height: 150, // Reduced size
                color: {
                    dark: '#000000',
                    light: '#ffffff'
                }
            }),
            createBarcodeImage(chassisNo)
        ]);

        if (!pdiData?.success) return false;
        if (!qrImage || !barcodeImage) {
            console.error('QR or Barcode generation failed');
            return false;
        }

        const container = createLabelContainer(pdiData.data, qrImage, barcodeImage);

        // Properly add container to DOM and style it
        container.style.backgroundColor = '#ffffff';
        container.style.position = 'fixed';
        container.style.top = '0';
        container.style.left = '0';
        container.style.zIndex = '-9999';
        document.body.appendChild(container);

        // Wait for images to load
        await Promise.all(
            Array.from(container.querySelectorAll('img')).map(
                img => img.complete ? Promise.resolve() : new Promise(resolve => img.onload = resolve)
            )
        );

        // Optimize html2canvas settings
        const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: false,
            width: 357.165,
            height: 470.866,
            backgroundColor: '#ffffff',
            imageTimeout: 0,
            removeContainer: true,
            foreignObjectRendering: true,
            letterRendering: true,
            onclone: (clonedDoc) => {
                const clonedContainer = clonedDoc.querySelector('div');
                if (clonedContainer) {
                    clonedContainer.style.backgroundColor = '#ffffff';
                    Array.from(clonedContainer.querySelectorAll('*')).forEach(el => {
                        if (getComputedStyle(el).backgroundColor === 'rgba(0, 0, 0, 0)') {
                            el.style.backgroundColor = '#ffffff';
                        }
                    });
                }
            }
        });

        document.body.removeChild(container);

        // Convert canvas to JPEG with white background
        const canvasBlob = await new Promise(resolve => {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const ctx = tempCanvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
            ctx.drawImage(canvas, 0, 0);
            tempCanvas.toBlob(resolve, 'image/jpeg', 1.0);
        });

        // Optimize PDF creation
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [95, 125],
            compress: true,
            putOnlyUsedFonts: true,
            precision: 2,
            hotfixes: ['px_scaling']
        });

        const arrayBuffer = await canvasBlob.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);

        pdf.addImage(uint8Array, 'JPEG', 0, 0, 95, 125, undefined, 'FAST');

        const filename = `pdi-${chassisNo}-${Date.now()}.pdf`;
        const pdfBlob = pdf.output('blob', { compress: true });

        const formData = new FormData();
        formData.append('file', pdfBlob, filename);

        // Parallel upload and print requests
        const [uploadResponse] = await Promise.all([
            api.post(warehouseConfig.uploadEndpoint, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                maxBodyLength: Infinity,
                maxContentLength: Infinity,
                timeout: 30000,
                decompress: false,
                responseType: 'json'
            })
        ]);

        if (uploadResponse.status === 200 && uploadResponse.data?.url) {
            const printResponse = await api.post(warehouseConfig.printEndpoint, {
                FilePath: uploadResponse.data.url,
                WarehouseId: warehouseId
            }, {
                timeout: 10000
            });

            if (printResponse.status === 200) {
                return true;
            }
            throw new Error('Failed to send print request');
        }
        throw new Error('Failed to upload PDF or URL not received');
    } catch (error) {
        console.error('Error in print process:', error);
        toast.error('Etiket yazdırılırken bir hata oluştu');
        return false;
    }
};